import React from 'react';
import img1 from '../../../assets/img/banner/banner-1.jpg';
import img2 from '../../../assets/img/banner/banner-2.jpg';
import img3 from '../../../assets/img/banner/banner-3.jpg';
import img4 from '../../../assets/img/banner/banner-4.jpg';
import BannerItem from './BannerItem';
const bannerInfo = [
    {
        image : img1,
        title : 'wedding Season',
        info : 'wedding season extends from late spring and continues through early fall',
        prev : 4,
        id : 1,
        next : 2
    },
    {
        image : img2,
        title : 'Nature Photography',
        info : 'Nature photography is a wide range of photography taken outdoors and devoted to displaying natural elements ',
        prev : 1,
        id : 2,
        next : 3
    },
    {
        image : img3,
        title : 'Party Photography',
        info : 'Party photography is a specialist genre that involves capturing images at an event.',
        prev : 2,
        id : 3,
        next : 4
    },
    {
        image : img4,
        title : 'Hill Photography',
        info : 'A hill is a piece of land that rises higher than everything surrounding it',
        prev : 3,
        id : 4,
        next : 1
    },
]
const Banner = () => {
    return (
        <div className="carousel w-full h-2/5">
            {
                bannerInfo.map(slide => <BannerItem 
                    key = {slide.id}
                    slide = {slide}
                    >
                    </BannerItem>)
            }
        </div>
    );
};

export default Banner;